import React from 'react'
import {Peripheral,PinMap} from "./device/peripheral";
import {updatePinStatus} from '../../utes/appUtils';

class PeripheralPinArray extends React.Component {
    constructor(props) {
        super(props);

        this.handleChange = this.handleChange.bind(this);
    }

    handleChange = (peripheralName, X, clickedPin) => {
	this.props.clickedPinCallback(peripheralName, X, clickedPin);
    };

    handlePullupChange = (peripheralName, X, clickedPin) => {
        this.props.clickedPullupCallback(clickedPin);
    };

    render() {

        let PinArray = Array(34).fill( null);
        let activePeripherals = [];
        this.props.peripherals.forEach((peri) => {
            if (peri.selected === true) {
                activePeripherals.push(peri);
            }

            updatePinStatus(peri, PinArray);
        });
        let divStyle={
            position: 'relative'
        };
        return (
            <div style={divStyle}>
                <PinMap pins={this.props.pinMap}
                        pinStatus={this.props.pinStatus}
                        pullUps={this.props.pullUps}
                        selectedBoard={this.props.selectedBoard}
                        TMCActive={this.props.TMCActive}
                        force_TMC={this.props.force_TMC}
                        pinMap={this.props.pinMap}
                        clickedPullupCallback={this.handlePullupChange}/>

                 {activePeripherals.map((peri) =>{
                        return <Peripheral key={peri.name}
                                           selectedBoard={this.props.selectedBoard}
                                           TMCActive={this.props.TMCActive}
                                           force_TMC={this.props.force_TMC}
                                           peripheral={peri}
                                           pinLocation={peri.pinLocation}
                                           pinStatus={this.props.pinStatus}
                                           pinMap={this.props.pinMap}
                                           clickedPinCallback={this.handleChange}/>
                    }
                )}
            </div>
        );
    }
}

export default PeripheralPinArray;
